import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export const siteDomain = 'https://www.kaiyuntiyu.com';

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteDomain,
    description: siteInfo.description,
    slogan: siteInfo.slogan,
    foundingDate: siteInfo.established,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: siteInfo.contact.phone,
      contactType: 'customer service',
      availableLanguage: 'Chinese',
      email: siteInfo.contact.email,
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: siteInfo.contact.address,
      addressCountry: 'CN',
    },
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.fullName,
    url: siteDomain,
    description: siteInfo.description,
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteDomain}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getWebPageSchema(title: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.fullName,
      url: siteDomain,
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function getArticleSchema(article: (typeof articles)[0]) {
  const category = categories.find((c) => c.slug === article.category);
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: article.date,
    dateModified: article.date,
    image: article.image,
    url: `${siteDomain}/article/${article.slug}`,
    publisher: {
      '@type': 'Organization',
      name: siteInfo.name,
      url: siteDomain,
    },
    articleSection: category?.name || '',
    inLanguage: 'zh-CN',
    wordCount: article.readTime ? parseInt(article.readTime) * 300 : 1500,
  };
}

export function getFAQSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: siteInfo.faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}